import { useQuery } from '@tanstack/react-query';
import { useFetch } from '~/hooks';
import { userConfigSchema } from '~/schemas/organizations';
import { routes } from './routes';

export function useGetUserConfig(enabled = true) {
  const { fetchData } = useFetch();

  return useQuery({
    enabled,
    queryFn: () => fetchData(routes.userConfig.getUserConfig, { response: userConfigSchema }),
    queryKey: ['user-config'],
  });
}
